namespace Matrix.Workflow {
    export interface ClientFunctionSummaryForm {
        FunctionName: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        TriggerType: ClientFunctionTriggerTypeEditor;
        TriggerDefinition: Serenity.StringEditor;
        WorkflowInstanceId: Serenity.IntegerEditor;
        InvocationHistory: ClientFunctionInvocationHistoryGrid;
    }

    export class ClientFunctionSummaryForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.ClientFunctionSummary';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ClientFunctionSummaryForm.init)  {
                ClientFunctionSummaryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = ClientFunctionTriggerTypeEditor;
                var w2 = s.IntegerEditor;
                var w3 = ClientFunctionInvocationHistoryGrid;

                Q.initFormType(ClientFunctionSummaryForm, [
                    'FunctionName', w0,
                    'Description', w0,
                    'TriggerType', w1,
                    'TriggerDefinition', w0,
                    'WorkflowInstanceId', w2,
                    'InvocationHistory', w3
                ]);
            }
        }
    }
}
